module.exports = __webpack_public_path__ + "static/1 (3)-0bf1b191fa9819741cc2bd8ebfcbf349.png";